const { makeStyles } = require("@material-ui/core");

export const useStyles = makeStyles((theme) => ({
  pageHeaderWrap: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: "15px 0px",
    borderRadius: "15px",
  },
  formHeader: {
    display: "flex",
    alignItems: "center",
  },
  backIcon: {
    border: "1px solid rgba(0, 0, 0, 0.54)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "10px",
    padding: "5px 8px",
    borderRadius: "5px",
    cursor: "pointer",
  },
  header: {
    ...theme.typography.h1,
  },
}));
